module.exports = __webpack_public_path__ + "static/verbego-2afc125c119603277782910b74e2c06b.png";